import { render, staticRenderFns } from "./Process_Review.vue?vue&type=template&id=69e6c610&"
import script from "./Process_Review.vue?vue&type=script&lang=js&"
export * from "./Process_Review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports